module.exports = __webpack_public_path__ + "img/14.942b4e7d.jpg";